import { render } from "./ProductImage.vue?vue&type=template&id=3f131b0e&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=3f131b0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f131b0e"]])

export default __exports__